import { IconProps } from "../../types/genereal";
import { IconWrapper } from "../ui/IconWrapper";

export const StarsOutlineIcon = ({
  width = "24",
  height = "24",
  color = "currentColor",
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.4434 13.2227L10.5381 13.4619L10.7773 13.5566L14.3857 15L10.7773 16.4434L10.5381 16.5381L10.4434 16.7773L9 20.3857L7.55664 16.7773L7.46191 16.5381L7.22266 16.4434L3.61426 15L7.22266 13.5566L7.46191 13.4619L7.55664 13.2227L9 9.61426L10.4434 13.2227ZM17.4395 6.20898L17.5352 6.46484L17.79 6.56055L20.292 7.49902L17.791 8.43848L17.5352 8.53418L17.4395 8.78906L16.5 11.292L15.5615 8.78906L15.4658 8.53418L15.2109 8.43848L12.707 7.49902L15.2109 6.56055L15.4658 6.46484L15.5615 6.20898L16.5 3.70703L17.4395 6.20898Z"
          stroke={color}
        />
      </svg>
    </IconWrapper>
  );
};
